export default __webpack_public_path__ + "static/media/gulp.6b350605.png";